export const MUTATION_GROUP = 'singleLineTextFields' as const;
